// Storage 封装类
// 暂只用于历史记录的存储
import utils from "../utils/util";
class Storage {
  constructor(storageKey = 'history', defaultVal = []) {
    this.maxLen = 80;     // 最大长度为 80
    this.storageKey = storageKey;
    try {
      this.list = JSON.parse(localStorage.getItem(this.storageKey)) || defaultVal || []; // 缓存到内存中
    } catch(e) {
      this.list = []
    }
    this.listLen = this.list.Length || 0;
  }

  setMax(num) {
    this.maxLen = num
  }

  _store() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.list));
    this.listLen = this.list.length;
  }

  setList(list) {
    this.list = list;
    this._store()
  }

  push (data) {
    setTimeout(() => {
      this.list.unshift(data);
      this.list = utils
        .quickSort(this.list, "SendDateTime")
        .splice(0, 80);
      this._store()
    }, 0);
  }

  getAll() {
    return this.list.reverse();
  }

  getByPage(pageIndex, pageSize = 10) {
    let i = pageIndex * pageSize
    let max = (pageIndex+1) * pageSize
    let arr = []
    for (;i < max && this.list[i]; i++) {
      arr.push(this.list[i]);
    }
    return arr.reverse()
  }
}


export default Storage;



// WEBPACK FOOTER //
// ./src/utils/Storage.js